<template>
  <div class="CYTdetail">
    <div class="CYTdetail-banner" :class="{ load: bannerList.length === 0 }">
      <div class="swiper-container pic">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
            <img class="pc" :src="item.img" alt="" />
            <img class="wap" :src="item.img2" alt="" />
          </div>
        </div>
        <div class="swiper-pagination" v-if="bannerList.length > 1"></div>
      </div>
    </div>
    <div class="CYT-detail-info">
      <div class="article-content">
        <div class="article">
          <div class="CYT-detail-title">太阳永照——塱头人家的安居与乐业</div>
          <div class="CYT-sub-title">策展人：陆翔</div>
          <div class="CYT-sub-title">常展</div>
          <div class="CYT-sub-title">展览时间：每日10:00-18:00（免费参观）</div>
          <div class="CYT-sub-title">
            展览地点：广州市花都区塱头村三馀里积墨楼（旧屋区东四巷150-156号）
          </div>
          <div class="detail-dec">
            展览所在的积墨楼修建于清道光年间，是塱头黄氏第二十二世祖黄友的旧宅。黄友名挺富，号谷诒，他的家宅积墨楼如今是广州花都区的登记保护文物单位。展览贯穿积墨楼这组民居的八个院落，我们尝试在一百多年前的这一生活空间中，寻找生活的含义与态度，看中国传统民间社会里，普通人如何安顿自己。
          </div>
          <div class="detail-dec">
            积墨楼的展览分为三个篇章，分别是“安其身”、“安其心”和“安于常”。“安其身”，关注人们如何在村落、家宅和庭园中营建自己的生活空间，并在勤恳的劳作中安身立业；“安其心”，关注人们如何安排自身与祖先和神明的关系，又如何在人际人情中彼此支撑，相安与共；“安于常”，关注生活日常如何以其内在的稳定，对抗命运无常的际遇，从而获得某种近乎恒常的力量。
          </div>
          <div class="detail-dec">
            太阳永照，希望长存。让我们一同感受塱头及其身后的乡土中国，进而反观思量：在一个以日新月异为尚的世界里，何处可安身心？
          </div>
          <div class="detail-dec">
            策展及展陈设计团队 <br />
            陆翔、陈晓宇、刘博、李国星、龚勤、黄奕阳｜陆工作室 <br />
            王名南｜访落工作室
          </div>
          <div class="detail-dec">
            平面设计团队 <br />
            章寿品｜Max Office <br />
            韩建伟、王诗颖｜co-Design平行实践
          </div>
          <div class="detail-dec">
            照片拍摄及后期制作 <br />毕应胜，孙海霆，Gion von Albertini（瑞士）
          </div>
          <div class="detail-dec">
            《云下塱头》视频拍摄及后期制作 <br />肖石明
          </div>
          <div class="detail-dec">
            东二院五彩投光装置制作 <br />张林、杨欣烨 ｜ 大阳大树工作室
          </div>
          <div class="detail-dec">
            布展现场实施团队 <br />李磊、曾健峰 ｜深圳市广米科技有限公司
          </div>
          <div class="detail-dec">特别鸣谢</div>

          <div class="detail-dec">
            参与并支持展览筹备的部分塱头村民（依姓氏笔画排序）
            <br />汤秀连、汤颖聪、李桂珍、杨新有、陈华、陈秀、范淦昌、林少群、罗玉珍、罗翠欢、周少芳、骆细凤、骆慧霞、唐景峰、黄卫昌、黄子毅、黄日华、黄心菊、黄仕标、黄光华、黄伟生、黄伟林、黄伟强、黄杞平、黄应才、黄间清、黄忍和、黄泽成、黄泽林、黄泽贤、黄学举、黄细根、黄玲、黄智雲、黄锦波、黄满棠、黄群英、谭金梅（陆续更新）
          </div>
        </div>
      </div>
      <div class="grey-line"></div>
      <EventExhibition :showData="actList" />
      <div class="share-box">
        <ShareQr :showApplet="false" :showHomeStay="false" :showLodg="false"/>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import ShareQr from "../components/shareQr.vue";
import EventExhibition from "../components/eventExhibition.vue";

export default {
  name: "CYTdetail",
  components: {
    ShareQr,
    EventExhibition,
  },
  data() {
    return {
      content: "",
      pageIndex: 1,
      bannerList: [
        {
          id: 1,
          img: require("@/assets/rural-banner2.jpg"),
        },
        {
          id: 2,
          img: require("@/assets/rural-banner3.jpg"),
        },
      ],
      actList: [
        {
          title: "过白",
          label: "从香炉到天际1",
          src: require("../../assets/rural-banner5.jpg"),
        },
        {
          title: "过白2",
          label: "从香炉到天际",
          src: require("../../assets/rural-banner5.jpg"),
        },
      ],
    };
  },
  watch: {
    pageIndex(val, oldval) {
      if (val !== oldval) {
        this.initList();
      }
    },
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      this.init();
      this.initList();
    },
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
  },
  methods: {
    init() {
      /* eslint-disable no-new */
      new Swiper(".swiper-container", {
        pagination: ".swiper-pagination",
        paginationClickable: true,
         autoplay: false,
        loop: true,
        speed: 3000,
      });
    },
  },
};
</script>

<style scoped>
.CYTdetail-banner {
  position: relative;
  min-height: calc(100vw * 0.35);
}
.CYTdetail-banner .pic,
.CYTdetail-banner img {
  width: 100%;
  height: 20px;
  min-height: 720px;
}
.CYTdetail {
  margin-top: 110px;
}
.swiper-pagination {
  text-align: right;
  padding-right: 280px;
}
.swiper-pagination >>> .swiper-pagination-bullet {
  width: 20px;
  height: 4px;
  border-radius: 0;
  margin: 0;
  padding: 0;
}

.swiper-pagination >>> .swiper-pagination-bullet-active::before {
  height: 0;
}
.CYTdetail-banner .swiper-pagination >>> span {
  margin: auto 4px !important;
  opacity: 1;
  width: 20px;
  height: 4px;
  background: url(../../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  border-radius: 0;
}
.CYTdetail-banner .swiper-pagination >>> .swiper-pagination-bullet-active {
  width: 20px;
  height: 4px;
  background: none;
  position: relative;
  background: url(../../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
}
.CYT-detail-info {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 100px auto;
  background-color: #fff;
}
.article-content {
  width: 100%;
}
.article {
  width: 1060px;
}
.share-box {
  position: absolute;
  right: 50px;
  top: 200px;
}
.CYT-detail-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.detail-sub-title {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 700;
}
.detail-dec {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 400;
}
.grey-line {
  width: 100%;
  height: 1px;
  background: #d8d8d8;
}
.show-act-box {
  width: 100%;
  margin: 60px auto 90px;
}
.act-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.CYT-sub-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  margin: 10px 0;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  padding-right: 15px;
  cursor: pointer;
}
.sub-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-top: 10px;
}
.title-right::after {
  content: "";
  position: absolute;
  top: 55%;
  right: 0px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(45deg);
  transform: translateY(-45%) rotate(45deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
@media (max-width: 768px) {
}
@media (max-width: 640px) {
}
</style>
